import { defineComponent } from "vue";
import { isAex, aexLogo } from "@/brand";

import { COMPONENT_NAME, SVG } from "./attributes";

import { SharedLanguage } from "@/components/shared";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    SharedLanguage,
  },
  computed: {
    displayedLogo(): string {
      return isAex ? aexLogo : SVG.logo;
    },
  },
});
